import Vue from 'vue'
import Tooltip from './Tooltip.vue'
import MultiSelect from './MultiSelect.vue'
import MultiSelectDateRangePicker from './MultiSelectDateRangePicker.vue'
import StickyHeaderLayout from '../views/layout/StickyHeaderLayout.vue'
import '../icons'

/**
 * Register global components
 */
Vue.component('gx-tooltip', Tooltip)
Vue.component('gx-select', MultiSelect)
Vue.component('gx-date-range-select', MultiSelectDateRangePicker)
Vue.component('sticky-header-layout', StickyHeaderLayout)
